// React.
import React from 'react';

// Material UI.
import Paper from '@material-ui/core/Paper';

// Components.
import OrderConfirmationSettings from '../settings/OrderConfirmationSettings';

// Styles.
import useStyles from './SettingsStyles';

const OrderConfirmationSettingsPage = () => {
  const classes = useStyles();

  return (
    <Paper className={ classes.paper } elevation={3} square={false} variant="elevation">
      <OrderConfirmationSettings />
    </Paper>
  )
}

export default OrderConfirmationSettingsPage;
